import { observer } from "mobx-react";
import { useEffect, useState } from "react";
import { Link, useParams } from "react-router";
import apiAgent from "../../../app/api/apiAgent";
//import LoadingComponent from "../../../app/layout/LoadingComponent";
import { OfficeModel } from "../../../app/models/OfficeModel";
import { UserModel } from "../../../app/models/UserModel";
import { useStore } from "../../../app/stores/store";
import HeaderWrapper from "../../header/HeaderWrapper";
import OfficeBox from "./OfficeBox";
import { ConfirmationModalProps } from "../../../app/models/ModalControlProps/ConfirmationModalProps";
import AjaxLoader from "../../../app/common/common-components/AjaxLoader";
import Breadcrumb from "../../../app/common/common-components/Breadcrumb";

export default observer(function SaveOfficePage() {
  let varConfirmModalProps: ConfirmationModalProps = {
    showModal: false,
    isConfirmed: (result: boolean) => {},
    title: "",
    body: "",
  };

  const [office, setOffice] = useState<OfficeModel>();
  const [isLoading, setIsLoading] = useState(true);
  const [confirmationModalProps, setConfirmationModalProps] = useState<ConfirmationModalProps>(varConfirmModalProps);
  const {
    userStore: { userSession, logout, isLoggedIn },
  } = useStore();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search); // id=123
    let officeId: string = "";
    if (params.has("ID")) {
      const id = params.get("ID");
      officeId = id !== null ? id : "";
    }

    setIsLoading(true);
    apiAgent.Setting.saveOffice(officeId)
      .then((response: OfficeModel) => {
        let oOffice: OfficeModel = response;
        setOffice(oOffice);

        //console.log("office", oOffice);
      })
      .catch((error: any) => {
        console.log(error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  document.title = "Base - Save Office";

  if (isLoading) {
    return <AjaxLoader />;
  } else if (!isLoading && office) {
    return (
      <>
        <div className="save-office-page container-fluid">
          <Breadcrumb
            breadcrumbs={[
              { text: "Home", path: "/" },
              { text: "Settings", path: "/settings" },
              { text: "Offices", path: "/settings/offices" },
              { text: !office.officeID ? "Create" : office.name },
            ]}
          />
          <div className="row">
            <div className="hidden-sm col-md-2"></div>
            <div id="content" className="col-sm-12 col-md-8">
              <OfficeBox data={office} iscreate={!office.officeID ? true : false} setConfirmationModalProps={setConfirmationModalProps} />
            </div>
            <div className="hidden-sm col-md-2"></div>
          </div>
        </div>
      </>
    );
  } else {
    return <></>;
  }
});
